import UserGalleryForm from 'cms/components/forms/UserGalleryForm';
import UserTalentGalleryItem from 'cms/components/items/UserTalentGalleryItem'
import UserGalleryController from 'cms/controller/user/UserGalleryController'

import React from 'react'
import Modal from 'react-modal';

function UserGallery({ userId }) {

    const { userGalleries, setUserGalleries, setAddModalIsOpen, addModalIsOpen, closeModal, isLoading } = UserGalleryController(userId)

    return (
        <div className="jury-gallery-panel">
            <div className="jury-gallery-toolbar">
                <h2 className="jury-gallery-toolbar-title">User gallery</h2>
                <button type="button" className="btn btn-cm btn-sm" onClick={() => { setAddModalIsOpen(true) }}>
                    <i className="fa fa-plus" /> Add
                </button>
            </div>

            {isLoading && (
                <p className="jury-gallery-empty text-center mb-0">Loading gallery…</p>
            )}

            {!isLoading && (!userGalleries || userGalleries.length === 0) && (
                <p className="jury-gallery-empty text-center mb-0">No gallery items yet. Add a video or link to get started.</p>
            )}

            {!isLoading && userGalleries && userGalleries.length > 0 && (
                <div className="talent-cards-grid episode-gallery-cards-grid user-gallery-cards-grid">
                    {userGalleries.map((item, index) => (
                        <div
                            key={item.id}
                            className="talent-card-col"
                            style={{ animationDelay: `${Math.min(index, 20) * 45}ms` }}
                        >
                            <UserTalentGalleryItem
                                item={item}
                                delete_url={"api/usergallery"}
                                onDelete={(id) => {
                                    let temp = userGalleries.filter((g) => g.id !== id)
                                    setUserGalleries(temp)
                                }}
                            />
                        </div>
                    ))}
                </div>
            )}

            {addModalIsOpen &&
                <Modal
                    closeTimeoutMS={500}
                    isOpen={addModalIsOpen}
                    onRequestClose={closeModal}
                    className="Modal"
                    overlayClassName="Overlay"
                >
                    <div className="modal-content">
                        <div className="modal-header">
                            <button type="button" className="close" onClick={closeModal}>
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body text-center">
                            <UserGalleryForm userId={userId} callback={(item) => {
                                let temp = [item, ...(userGalleries || [])]
                                setUserGalleries(temp)
                                setAddModalIsOpen(false);
                            }} />
                        </div>

                    </div>
                </Modal>
            }
        </div>
    )
}

export default UserGallery;
